// extracted by mini-css-extract-plugin
export default {"check_row":"styles_check_row__pQ4wi","check_col_75":"styles_check_col_75__2OF-e","check_col_25":"styles_check_col_25__e1JKa","row":"styles_row__BrVxP"};